module.exports = __webpack_public_path__ + "img/2015001.391c5d63.svg";